import { RelationType } from "__generated__/enums";

export const relationTypesAndBooleans = [
	{ field: "customer", key: "CUSTOMER", type: RelationType.Customer },
	{ field: "operator", key: "OPERATOR", type: RelationType.Operator },
	{ field: "shipManager", key: "SHIP_MANAGER", type: RelationType.ShipManager },
	{ field: "skipper", key: "SKIPPER", type: RelationType.Skipper },
	{ field: "consignor", key: "CONSIGNOR", type: RelationType.Consignor },
	{ field: "supplier", key: "SUPPLIER", type: RelationType.Supplier },
	{ field: "shippingCompany", key: "SHIPPING_COMPANY", type: RelationType.ShippingCompany },
	{ field: "locationRelation", key: "LOCATION_RELATION", type: RelationType.LocationRelation },
	{ field: "applicationRelation", key: "APPLICATION_RELATION", type: RelationType.ApplicationRelation },
	{ field: "agent", key: "AGENT", type: RelationType.Agent },
	{ field: "containerOperator", key: "CONTAINER_OPERATOR", type: RelationType.ContainerOperator },
	{ field: "broker", key: "BROKER", type: RelationType.Broker },
	{ field: "surveyor", key: "SURVEYOR", type: RelationType.Surveyor },
];

export const toFormRelation = (relation) => {
	return {
		id: relation.id,
		name: relation.name,
		type: determineRelationType(relation),
		contacts: convertContractsToType(relation.contacts),
	};
};

const determineRelationType = (relation) => {
	if (relation.isAgent) {
		return RelationType.Agent;
	} else if (relation.applicationRelation) {
		return RelationType.ApplicationRelation;
	} else if (relation.broker) {
		return RelationType.Broker;
	} else if (relation.isConsignor) {
		return RelationType.Consignor;
	} else if (relation.isContainerOperator) {
		return RelationType.ContainerOperator;
	} else if (relation.isCustomer) {
		return RelationType.Customer;
	} else if (relation.isLocationRelation) {
		return RelationType.LocationRelation;
	} else if (relation.isOperator) {
		return RelationType.Operator;
	} else if (relation.isShippingCompany) {
		return RelationType.ShippingCompany;
	} else if (relation.isShipManager) {
		return RelationType.ShipManager;
	} else if (relation.isSkipper) {
		return RelationType.Skipper;
	} else if (relation.isSupplier) {
		return RelationType.Supplier;
	} else if (relation.surveyor) {
		return RelationType.Surveyor;
	} else {
		return undefined;
	}
};

const convertContractsToType = (contacts) => {
	return contacts?.filter(c => !!c && !!c.name);
};
